var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileupload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 45.338,
    viewBox: "0 0 35 45.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_upload_document_727726",
    "data-name": "noun_upload document_727726",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M233.335,699.209H219.063V670.633l6.309-5.389h18.673V685.2",
    transform: "translate(-219.063 -661.641)",
    fill: "none",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M238.252,658.057h18.967v22.521",
    transform: "translate(-228.633 -658.057)",
    fill: "none",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 15.916,
    transform: "translate(4.324 12.514)",
    fill: "none",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 15.916,
    transform: "translate(4.324 16.307)",
    fill: "none",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x2: 15.916,
    transform: "translate(4.324 20.1)",
    fill: "none",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 11.279,
    transform: "translate(4.324 23.894)",
    fill: "none",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x2: 8.167,
    transform: "translate(4.324 27.687)",
    fill: "none",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(13.513 23.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(5.962 5.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    y1: 9.106,
    transform: "translate(3.781)",
    fill: "none",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M257.914,719.774l3.781-3.781,3.781,3.781",
    transform: "translate(-257.914 -715.993)",
    fill: "none",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 9.743,
    cy: 9.743,
    r: 9.743,
    fill: "none",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileupload);
export default __webpack_public_path__ + "static/media/fileupload.b9e1eb070e42f88251bdb379888092b6.svg";
export { ForwardRef as ReactComponent };